<template>
  <div class="kl-faq">
    <div class="kl-faq__container container">
      <div class="row">
        <div
          class="col-12 px-0 d-flex flex-md-row flex-column justify-content-between align-items-center kl-faq__buttons-wrapper"
        >
          <router-link
            :to="`/pomoc/${name}#${$route.params.paragraph}`"
            class="btn btn-default btn-cta--stroke-only text-uppercase"
          >
            <BackArrow class="mr-4 kl-faq__buttons-arrow" />
            Wróc do menu
          </router-link>
          <h6 class="heading6 text-blue pt-4 pt-md-0">
            {{ title }}
          </h6>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pb-5">
          <div class="kl-faq__question-wrapper">
            <h2 class="heading4 my-4">
              {{ data.question }}
            </h2>
            <!-- eslint-disable vue/no-v-html -->
            <div class="body3" v-html="data.answer"></div>
            <!--eslint-enable-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpContent from "../content/help.json";
import BackArrow from "./icons/BackArrow.vue";

function _find(collection, key, value) {
  for (const o of collection) {
    for (const [k, v] of Object.entries(o)) {
      if (k === key && v === value) {
        return o;
      }
      if (Array.isArray(v)) {
        const _o = _find(v, key, value);
        if (_o) {
          return _o;
        }
      }
    }
  }
}

export default {
  name: "HelpDetail",
  components: { BackArrow },
  data() {
    const module = helpContent.find(
      (item) => item.name === this.$route.params.module
    );
    const data = _find(
      module.chapters || module.topics,
      "id",
      this.$route.params.paragraph
    );
    return {
      data,
      title: module.title,
      name: module.name,
    };
  },
  mounted() {
    document.title = "Pomoc";
  },
};
</script>
